export default __webpack_public_path__ + "static/media/mobile_info_char.c78843eb.png";